<template>
  <v-layout wrap pa-3>
      <v-flex sm6 pr-2>
        <v-text-field clearable v-model="adminFilterSearch" :label="$t('Admin.Search')" append-icon="mdi-magnify" />                
      </v-flex>
      <v-flex sm6 pl-2 v-if="enseignes.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminGliderOwnerFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="enseignes" :label="$t('Admin.Glider.List.FilterOwner')"></v-autocomplete>
      </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { FilterUser } from '@/models/filter/FilterUser'


@Component({
  name: 'AdminGliderFilter'
})
export default class AdminGliderFilter extends Vue {  

  //recupere les enseignes possédants au moins un utilisateur
  get enseignes() {
    return this.$store.myGetters.enseignes.filter(e => this.$store.myGetters.gliders.findIndex(g => g.ENS_ID == e.ENS_ID) > -1)
  }
  
  get adminGliderOwnerFilterIds() {
    return this.$store.myGetters.adminGliderFilter.ownerIds
  }
  set adminGliderOwnerFilterIds(value) {
    this.$store.myActions.GLIDER_UPDATE_FILTER_ADM({
      ownerIds:value
    })
  }  

  get adminFilterSearch() {
    return this.$store.myGetters.adminGliderFilter.search
  }
  set adminFilterSearch(value) {
    this.$store.myActions.GLIDER_UPDATE_FILTER_ADM({
      search:value == null?"":value
    })
  } 
}
</script>
